"use client";

import { useRef, useState } from "react";
import { motion } from "framer-motion";


const Products = () => {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const products = [
    {
      title: "Axial Fans",
      description: "High-performance axial fans designed for superior airflow, ventilation, and industrial HVAC applications.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhDSrUEu-71n6CF5JrDaqoKM_UPXnaJyivDmVQylLBLjrqFIt6RHtH39PSYbDBGF0z2iuRvYcGt21cQUoIzCavHA8-ImiNKv3iJ08HIiNjgA9R4yA32Y7d06bqZQ3hi3HRSyM0jvs8dvsfLnmTWxMT-LRllc2eDHk5M5oF3bELCWk5hveIHmeoPmeEm1FuJ/s320/Axial%20Fans.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Backward Blower",
      description: "Energy-efficient backward blowers engineered for low noise and reliable airflow performance.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3DfIXQelS4U9Ufyh5Uc5-rywTN7-2itH0gYog1OAT5jAs2lNwcD2YAlFC2UWp07pKKHMRVB75ezx1apKgoz7mj9hLAq9rjanfieEqxc6AGkplZ5LYA7g6J0xQiJWkyL2Hh8F8LegLxP8b6yq-HUGg2Rx5nrKw08OXVJKpe3XcLB9MHKUxeQnvzcuNcUCj/s320/Backward%20Blower.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Condenser Unit",
      description: "Premium condenser units providing efficient cooling and long-lasting HVAC system performance.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgcnPZ_oPWrkZYY_Oe5rLPIfpXr11Ea82gzIcTjLNK6tct2yAIqyj5Cx-BHHco2xSV5uggD3Vb8bolZCN-gX3wSC5I7ooW6oCQq-F54j7Zo6Z7mxlOg2uSwIbe9Fac-lNfQxLIy9MyQ8J6PY8aFOfLCB05RDpjg0-rx8Nj0YSOIw3gAefjD8S_lPeRnFWqm/s320/Condenser.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Exhaust Unit",
      description: "Industrial exhaust units designed for effective air extraction and improved indoor air quality.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiXPYdCDBWKABNLYDVeceSJHuwTcunbOWYdUS2ccZIar5WJo_N4zMfKdCZJJFjW4aYa3d6VJO8ESJ-WzP1SLaP-JdpVwxOAhx80RerG5zCBfFzA8jvFrjwIXmBa2sB4voKlqi9Y0h8hbWk9lPlvwbzlST_SKnlucexVUdnFn0ego0s3yBiepPGtogWwrm_v/s320/Exhuast%20Unit.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Fan Coil Unit",
      description: "Compact fan coil units delivering consistent heating and cooling with high energy efficiency.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjDhSo7LGrg8dcrZmJfdA2iy11WS1qrLMbgyNpYeZZQgSLLEhpkXhtP_5n7aJ37m0-_1MsMr2_KQYrXa566brKfcemuaLh_8rgWFZ8ox1zkaIsIune0fAEU8sb-I-9Uoc_GKK055M_3AIimq88bncTj379qgpTR21I8zSpPQJ21U2vdSL6ssldpCD8ctljz/s320/Fan%20Coil%20Unit.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Floor Standing Cabinet",
      description: "Heavy-duty floor standing cabinets engineered for commercial and industrial HVAC environments.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgA2lL1039DNTKzu9PxWK0fHpcP3Q29bVtNMWaDgNcI3K1ICILYdeoXUwSK1nepSd6JQvRCvsEK8ugxaX9B5wKDAX9O1db3DVAcm0_U8TbnJEIr4hWcbeIt9_i3xTv6KfxjrzgPVT3sHB0bCjH1akzHG8KTSjykZF8uZxSfUaK4J1gQc1L_C_qP-3Da0ps2/s320/Floor%20Standing%20Cabinet.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Forward Blower",
      description: "Forward blowers offering smooth airflow, quiet operation, and dependable performance.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgLQ23AGf0krWLgX4am9UJpasC_Qy7lf_UuoboRCysFSWW3PdLLXBwx2VZK1CHdEencRDHrwxR980n2r12S2FQm2HPrj8h5EnCxMkITyq8xEmwS4VTYObzjAbauffs_3mIA1raPRrUPGZ3WoLRxO7d-udBcxilsqgUrEkVJfUQ3InBKDSj49vucVgQ9S2h0/s320/Forward%20Blower.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Package Type Unit",
      description: "All-in-one package HVAC units designed for maximum efficiency and simplified installation.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgjLBfM2xNG8JXzC9IYCPx1dppi-J5FfR_0diqf5x08ZsfziqNA1_S-J2f0tZ2X59nO-Ei4W06Qc6EZAlapCzSxGtpkRXhP6bDeetj5puEfM-MUzhXgbO1LrcGPUo1lky1p53rYK8yLnEStDGr0PRVF7pjyFWeA6PRf6Tu8431fmTKiPRlMxvQ50EQvVEkm/s320/Package%20Type%20Unit.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Scroll Chiller",
      description: "Reliable scroll chillers providing efficient cooling solutions for commercial facilities.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjFp6MRJCoY4U6Ah5p47NRNGM1boc9Lk7f6gjkNRj_7CtXtvjQ6DmRV5ZC7W0Bewq_6u9cCyreliPNt-bkSUDpVpOqEwbcQT3xCH1pJMHQAqkJQZFLhFbSDxJBkTW20ptqJReO2N2wuUJnZxK_r3rPNWfBLczGl4Qbip07xXPCcstP2tkMwI3jbCdtrHVYJ/s320/Scroll%20chiller.png=w352-h352-p-k-no-nu",
    },
    {
      title: "Tube Axial Fan",
      description: "Industrial tube axial fans built for high airflow capacity and demanding ventilation applications.",
      image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjheEyuo0WPVKrpGyzi0ZiGJYxfVioalc6QDuZ0D7nJ0X4ztte0AMzrucCGKShegMeiVZGHONgupbkM0EFOU7hlOS63G5W5ln-EdJVRMRjSXkMO2em2RAG0pDsqKAMRYMdUEqDYtl-bD8Q02AoXiLjB-U53HSARlr56GHgW0GVXw1rV_NyxtwVqzS50ueOs/s320/Tube%20Axial%20Fan.png=w352-h352-p-k-no-nu",
    },
  ];

  const goToSlide = (i) => {
    if (!sliderRef.current) return;

    const card = sliderRef.current.children[i];

    card.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest",
    });

    setActiveIndex(i);
  };

  return (
    <section className="py-24 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1f4ba5]">
            Our Products
          </h2>

          <p className="text-gray-500 mt-5 text-sm sm:text-base leading-7">
            AirEast HVACR delivers precision-engineered HVAC solutions built for
            industrial performance, efficiency, and long-term reliability.
          </p>
        </div>

        <div
          ref={sliderRef}
          className="
            mt-10
            flex gap-6
            overflow-x-auto
            overflow-y-hidden
            snap-x snap-mandatory
            scroll-smooth
            touch-pan-x
            [-ms-overflow-style:none]
            [scrollbar-width:none]
            [&::-webkit-scrollbar]:hidden
          "
        >
          {products.map((item, i) => (
            <motion.div
              key={i}
              transition={{ type: "spring", stiffness: 180 }}
              className="
              w-[90%]
  sm:w-[48%]
  lg:w-[calc((100%-3rem)/3)]
  min-w-[90%]
  sm:min-w-[48%]
  lg:min-w-[calc((100%-3rem)/3)]
  flex-shrink-0
  bg-white
  border border-gray-100
  rounded-2xl
  overflow-hidden
  snap-start
  shadow-sm
  hover:shadow-2xl
  transition-all
  duration-500
  hover:-translate-y-2
  group
              "
            >
              <div className="overflow-hidden bg-gray-50">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-60 object-contain p-5 group-hover:scale-105 transition duration-700"
                />
              </div>

              <div className="p-6 relative">
                <div className="absolute inset-0 bg-blue-500 opacity-0 group-hover:opacity-5 transition duration-500" />

                <h3 className="text-lg font-semibold text-gray-900 relative z-10">
                  {item.title}
                </h3>

                <div className="h-[2px] w-0 group-hover:w-1/2 bg-[#1f4ba5] transition-all duration-500 mt-2" />

                <p className="text-gray-500 text-sm leading-6 mt-4 relative z-10">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {products.map((_, i) => (
            <button
              key={i}
              onClick={() => goToSlide(i)}
              className={`transition-all duration-300 rounded-full ${activeIndex === i
                ? "w-7 h-2 bg-[#1f4ba5]"
                : "w-2 h-2 bg-gray-300"
                }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;